import React from 'react';
import { questionShape } from '../SummaryBlock.shape';

const Question = ({ id, question, answer }) => (
  <div className="grid-question" key={id}>
    {question && <span className="question">{question}</span>}
    {answer && <span className="answer">{answer}</span>}
  </div>
);

Question.propTypes = questionShape;
Question.defaultProps = {};

export default Question;
